import { createSelector } from 'reselect'
import { getGalleryType } from '~/app/store/config/reducer'
import { getDesignCreationTypes } from '~/app/store/debug/reducer'
import { hasImageSelector } from '~/app/store/designPersonalization/selectors'
import { DESIGN_CREATION_TYPE } from '~/shared/constants'

/**
 * Returns the effective `designCreationTypes` to send to Design Conductor.
 *
 * When photo personalization is applied on Auto galleries, `Clipart` is excluded.
 * Otherwise the raw value from state is passed through.
 */
export const effectiveDesignCreationTypesSelector = createSelector(
  getDesignCreationTypes,
  getGalleryType,
  hasImageSelector,
  (rawDesignCreationTypes, galleryType, imagePersonalized) =>
    galleryType === 'Auto' && imagePersonalized ? rawDesignCreationTypes?.filter((type) => type !== DESIGN_CREATION_TYPE.CLIPART) : rawDesignCreationTypes,
)
